import { Injectable } from '@angular/core';
import { WatchlistCreateRequest, Watchlist, WatchlistUpdateRequest, WatchlistCompanyAddRequest } from './monitoring.model';
import { HttpClient } from '@angular/common/http';
import { CompanySearchService } from '../company-search/services/company-search.service';
import { IWatchlistCompany, IWatchlistCompanyAddRequest, IWatchlistCompanyAddResponse, IWatchlistResponse } from './monitoring.model';

/** Lightweight API client for watchlist CRUD and bulk operations. */
@Injectable({
  providedIn: 'root'
})
export class MonitoringService {
  /** Base endpoint for watchlist APIs */
  private readonly apiUrl = '/backend/watchlists';

  constructor(
    private http: HttpClient,
    private companySearchService: CompanySearchService
  ) {}

  /** Create a new watchlist for current user */
  createWatchlist(watchlistData: WatchlistCreateRequest) {
    return this.http.post<IWatchlistResponse>(`${this.apiUrl}/create`, watchlistData, 
      {    headers:{
      Authorization: "Bearer " + localStorage.getItem("current_user_token")
    },
    responseType:'json'
  })
}
  /** List all watchlists for given user id */
  getUserWatchlists(userId: number){
    return this.http.get<IWatchlistResponse>(`${this.apiUrl}/user/${userId}`, 
      {    headers:{
        Authorization: "Bearer " + localStorage.getItem("current_user_token")
      },
      responseType:'json'
    })
  }

  // getWatchlist(watchlistId: number) {
  //   return this.http.get<Watchlist>(`${this.apiUrl}/${watchlistId}`, {    headers:{
  //     Authorization: "Bearer " + localStorage.getItem("current_user_token")
  //   },
  //     responseType:'json'
  //   })
  // }

  /** Get companies in a watchlist (204 when empty) */
  getWatchlistCompanies(watchlistId: number | undefined){
    return this.http.get<IWatchlistCompanyAddResponse>(`${this.apiUrl}/${watchlistId}/companies`, { headers:{
      Authorization: "Bearer " + localStorage.getItem("current_user_token")
    },
    responseType:'json'
    ,observe:'response'
  })
  }

  /** Get only entity IDs in a watchlist (lightweight endpoint) */
  getWatchlistEntityIds(watchlistId: number){
    return this.http.get<{payload: {entityids: string[]}, message: string}>(`${this.apiUrl}/${watchlistId}/companies/entityids`, { headers:{
      Authorization: "Bearer " + localStorage.getItem("current_user_token")
    },
    responseType:'json'
  })
  }

  /** Get entity IDs for all watchlists of a user (bulk endpoint) */
  getAllWatchlistsEntityIds(userId: number){
    return this.http.get<{payload: {[watchlistId: number]: string[]}, message: string}>(`${this.apiUrl}/user/${userId}/entityids`, { headers:{
      Authorization: "Bearer " + localStorage.getItem("current_user_token")
    },
    responseType:'json'
  })
  }

  /** Rename/update a watchlist */
  updateWatchlist(watchlistId: number, watchlistData: WatchlistUpdateRequest){
    return this.http.post<Watchlist>(`${this.apiUrl}/update/name/${watchlistId}`, watchlistData, { headers:{
      Authorization: "Bearer " + localStorage.getItem("current_user_token")
    },
    responseType:'json'
  })
  }
  

  /** Delete a watchlist */
  deleteWatchlist(watchlistId: number){
    return this.http.delete<{ message: string }>(`${this.apiUrl}/${watchlistId}`, { headers:{
      Authorization: "Bearer " + localStorage.getItem("current_user_token")
    },
    responseType:'json'
  })
  }

  /** Add a single company to a watchlist */
  addCompanyToWatchlist(watchlistId: number, entityId: string, entityName: string, entityGics: string |undefined, isin: string |undefined){ 
    const body :IWatchlistCompanyAddRequest = {
      entityid: entityId,
      entity_name: entityName,
      entity_gics: entityGics,
      isin: isin
    }
    return this.http.post<IWatchlistCompanyAddResponse>(`${this.apiUrl}/${watchlistId}/companies`, body, { headers:{
      Authorization: "Bearer " + localStorage.getItem("current_user_token")
    },
    responseType:'json'
  })
  }

  /** Remove a single company from a watchlist */
  removeCompanyFromWatchlist(watchlistId: number, entityId: string){
    return this.http.delete<{ message: string }>(`${this.apiUrl}/${watchlistId}/companies/${entityId}`, { headers:{
      Authorization: "Bearer " + localStorage.getItem("current_user_token")
    },
    responseType:'json'
  })
  }

  /** Bulk match uploaded companies to QuantIP entities */
  bulkMatchCompanies(companies: any[]){
    return this.http.post<any[]>(`${this.apiUrl}/bulk-match`, companies, { headers:{
      Authorization: "Bearer " + localStorage.getItem("current_user_token")
    },
    responseType:'json'
  })
  }


  /** Add multiple companies to a watchlist */
  addCompaniesToWatchlist(watchlistId: number, companies: any[]){
    return this.http.post<any>(`${this.apiUrl}/${watchlistId}/companies/bulk`, companies, { headers:{
      Authorization: "Bearer " + localStorage.getItem("current_user_token")
    },
    responseType:'json'
  })
  }
     
}
